import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const RevenueChart = ({ data }) => {
  const { t, currentLanguage } = useLanguage();

  const labels = {
    fr: {
      title: 'Revenus mensuels',
      revenue: 'Revenus',
      month: 'Mois'
    },
    ar: {
      title: t('dashboard.monthlyRevenues'),
      revenue: t('dashboard.revenues'),
      month: t('dashboard.month')
    }
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-warm-md">
          <p className="text-sm font-medium text-foreground mb-1">
            {payload?.[0]?.payload?.month}
          </p>
          <p className="text-sm text-primary font-semibold data-text">
            {payload?.[0]?.value?.toLocaleString()} MAD
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-warm border border-border">
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6">
        {labels?.[currentLanguage]?.title}
      </h3>
      <div className="w-full h-64 md:h-80" aria-label={labels?.[currentLanguage]?.title}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              tickFormatter={(value) => `${(value / 1000)?.toFixed(0)}k`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '14px' }}
              iconType="circle"
            />
            <Bar 
              dataKey="revenue" 
              fill="var(--color-primary)" 
              radius={[8, 8, 0, 0]}
              name={labels?.[currentLanguage]?.revenue}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueChart;